module.exports = __webpack_public_path__ + "img/logement-etage-premier.00b66d7f.png";